import React from 'react';
import CouponManagement from '../components/CouponManagement';

const Coupons = () => {
  return <CouponManagement />;
};

export default Coupons;